import { contactCard } from '../../../shared';

export const buyerTCCard = contactCard(
  'buySideContacts.buyersTC',
  'counterpartyTransactionCoordinator',
);
